module.exports = __webpack_public_path__ + "static/media/leaseActive1.e342cf02.png";